import { postData } from "./axiosConfig"


export const newsletter = async (body) => {
    return await postData('/news-letter-subscription', body)
}